import React, { useState, useContext } from 'react';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import Modal from 'react-awesome-modal';
import styled, { ThemeContext } from 'styled-components';

const SInnerModal = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1em;
  className: SInnerModal;
  height: 70vh
`;

interface ILowScoreVideo {
  currentUserScore: number;
}

const LowScoreVideo: React.SFC<ILowScoreVideo> = (props) => {
  const [isVisible, setIsVisible] = useState(true);

  const themeContext = useContext(ThemeContext);

  const handleClick = (event: any) => {
    event.preventDefault();
    setIsVisible(false);
  };

  return (
    <Modal
      visible={isVisible}
      width='70%'
      height='70%'
      effect='fadeInUp'
      onClickAway={() => setIsVisible(false)}
    >
      <SInnerModal>
        <p style={{ alignSelf: 'flex-end', marginTop: 0, marginBottom: 0 }}>
          <button style={{ border: 'none' }} onClick={handleClick}>
            X
          </button>
        </p>

        <img
          alt='form'
          src='https://form-bannastre.s3.eu-west-2.amazonaws.com/logo/logo_word.png'
          style={{ height: 'auto', width: '12vw', alignSelf: 'center' }}
        />

        <p
          style={{
            color: `${themeContext.textPrimary}`,
            marginTop: '1rem',
            marginBottom: 0,
            alignSelf: 'center',
            textAlign: 'center'
          }}
        >
          It sounds like you might need a little help.
        </p>
        <p
          style={{
            color: `${themeContext.textPrimary}`,
            marginTop: '0.2rem',
            marginBottom: '1.5rem',
            alignSelf: 'center',
            textAlign: 'center'
          }}
        >
          Why not take a moment to get to know your Form?
        </p>
        <p
          style={{
            color: `${themeContext.textPrimary}`,
            marginTop: '0.2rem',
            marginBottom: '1.5rem',
            alignSelf: 'center',
            textAlign: 'center'
          }}
        >
            <a href={"https://www.youtube.com/playlist?list=PL2FBNkF6kzg-_DWtQLlK_xi0RtI0v1MVf"}>Formscore Guidance Video Playlist</a>
        </p>
      </SInnerModal>
    </Modal>
  );
};

const mapStateToProps = (state: any) => {
  return { currentUserScore: state.currentUserScore };
};

const mapDispatchToProps = (dispatch: Dispatch) => {};

export default connect(mapStateToProps, mapDispatchToProps)(LowScoreVideo);
